import { render, staticRenderFns } from "./headFeeDetail.vue?vue&type=template&id=2e572a3e&scoped=true&lang=true&"
import script from "./headFeeDetail.vue?vue&type=script&lang=js&"
export * from "./headFeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./headFeeDetail.vue?vue&type=style&index=0&id=2e572a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e572a3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VRow,VTooltip})
